import { useTitle } from 'contexts/TitleContext';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DynamicTitle = () => {
  const { currentPageName } = useTitle();
  const location = useLocation();

  useEffect(() => {
    if (currentPageName) {
      document.title = `Awdiz - ${currentPageName}`;
    } else {
      const segments = location.pathname.substring(1).split('/');
      const routeName = segments
        .filter((segment) => segment)
        .pop()
        ?.split(/[-_]/)
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ');

      document.title = routeName ? `Awdiz - ${routeName}` : 'Awdiz';
    }
  }, [location, currentPageName]);

  return null;
};

export default DynamicTitle;
